import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to console so you can see the real crash instead of a blank page.
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: 40,
            background: "#080b14",
            color: "#e2e8f0",
            textAlign: "center",
          }}
        >
          <h2 style={{ margin: 0 }}>Something went wrong</h2>
          <p style={{ color: "rgba(226,232,240,0.6)", maxWidth: 480 }}>
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <button
            onClick={() => (window.location.href = "/profile")}
            style={{
              marginTop: 8,
              padding: "10px 20px",
              borderRadius: 10,
              border: "none",
              background: "#8b5cf6",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Go to Profile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;